import React, { useState, useEffect } from "react";
import ScreenHeading from "../../Utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../Utilities/ScrollService";
import Animations from "../../Utilities/Animations";
import "./Resume.css";

const Resume = (props) => {
  /* STATES */
  const [selectedBulletIndex, setSelectedBulletIndex] = useState(0);
  const [carousalOffsetStyle, setCarousalOffsetStyle] = useState({});

  let fadeInScreenHandler = (screen) => {
    if (screen.fadeInScreen !== props.id) return;

    Animations.animations.fadeInScreen(props.id);
  };
  const fadeInSubscription =
    ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  /* REUSABLE MINOR COMPONENTS */
  const ResumeHeading = (props) => {
    return (
      <div className="resume-heading">
        <div className="resume-main-heading">
          <div className="heading-bullet"></div>
          <span>{props.heading ? props.heading : ""}</span>
          {props.fromDate && props.toDate ? (
            <div className="heading-date">
              {props.fromDate + " - " + props.toDate}
            </div>
          ) : (
            <div></div>
          )}
        </div>
        <div className="resume-sub-heading">
          <span>{props.subHeading ? props.subHeading : ""}</span>
        </div>
        <div className="resume-heading-description">
          <span>{props.description ? props.description : ""}</span>
        </div>
      </div>
    );
  };

  /* STATIC RESUME DATA FOR THE LABELS*/
  const resumeBullets = [
    { label: "Education", logoSrc: "education.svg" },
    { label: "Work Experience", logoSrc: "work-experience.svg" },
    { label: "Skills and Expertise Level", logoSrc: "skills.svg" },
    { label: "Projects", logoSrc: "projects.svg" },
    { label: "Certifications", logoSrc: "skills.svg" },
    { label: "Interests", logoSrc: "interests.svg" },
  ];

  //here we have
  const programmingSkillsDetails = [
    { skill: "Git/GitHub", ratingPercentage: 80 },
    { skill: "AWS", ratingPercentage: 80 },
    { skill: "Jenkins", ratingPercentage: 90 },
    { skill: "Terraform", ratingPercentage: 75 },
    { skill: "Ansible", ratingPercentage: 65 },
    { skill: "Docker", ratingPercentage: 85 },
    { skill: "Kubernetes", ratingPercentage: 60 },
    { skill: "Prometheus", ratingPercentage: 70 },
    { skill: "Grafana", ratingPercentage: 70 },
    { skill: "Scripting (Shell, Python)", ratingPercentage: 75 },
  ];

  const projectsDetails = [
    {
      title: "Personal Portfolio Website",
      duration: { fromDate: "", toDate: "" },
      description:
        "A Personal Portfolio website to showcase all my details and projects in one place.",
      subHeading:
        "Technologies Used:   React JS, Git/GitHub, AWS (S3, EC2), Docker",
    },
    {
      title: "In Line Of Sight",
      duration: { fromDate: "", toDate: "" },
      description:
        "In case of accident or emergency, connects you directly via video with first responders to assist you over the phone before help arrives.",
      subHeading:
        "Technologies Used:   React JS, Git/GitHub, WordPress",
    },
    {
      title: "Massaging Boots",
      duration: { fromDate: "", toDate: "" },
      description:
        "New tech massaging boot that helps prevent tired, aching feet at work and on-the-go.",
      subHeading:
        "Technologies Used: ...",
    },
  ];

  const resumeDetails = [
    <div className="resume-screen-container" key="education">
      <ResumeHeading
        heading={"Graduate Professional Diploma in DevOps and Cloud Engineering"}
        subHeading={"Landmark Technologies - Mississauga, Canada"}
        // fromDate={"20XX"}
        // toDate={"20XX"}
      />

      <ResumeHeading
        heading={"Bachelor of Science: Biotechnology"}
        subHeading={"Kean University - Union, NJ"}
        // fromDate={"20XX"}
        // toDate={"20XX"}
      />

      <ResumeHeading
        heading={"Doctor of Pharmacy: Pharmacy"}
        subHeading={"Long Island University - BROOKLYN, NY"}
        // fromDate={"20XX"}
        // toDate={"20XX"}
      />
      
    </div>,

    /* WORK EXPERIENCE */
    <div className="resume-screen-container" key="work-experience">
      <div className="experience-container">
        <ResumeHeading
          heading={"Dominion Systems, Canada"}
          subHeading={"DevOps Engineer - Remote"}
          fromDate={"01/2021 "}
          toDate={" Present"}
          
        />
        <div className="experience-description">
          <span className="resume-description-text">
          Software Configuration management
          </span>
          <br />
          <span className="resume-description-text">
            &emsp;- &ensp;Automate CI & CD pipeline using Ansible, Nexus, Sonarqube, Maven, Jenkins
            Terraform and GIT.
          </span>
          <br />
          <span className="resume-description-text">
            &emsp;- &ensp;Automating AWS cloud deployments using Shell script, Jenkins. Writing inventory and manifest<br />
            &emsp;&emsp; files, and ansible playbooks. Containerized deployment in Kubernetes Clusters.
          </span>
          <br />
        </div>
      </div>

      <div className="experience-container">
        <ResumeHeading
          heading={"Dominion Systems"}
          subHeading={"Junior Cloud Engineer - Remote"}
          fromDate={"02/2019 "}
          toDate={" 12/2020"}
        />
        <div className="experience-description">
          <span className="resume-description-text">
            Interacted with development teams to provide cloud services from AWS in deployment activities.
          </span>
          <br />
          <span className="resume-description-text">
            &emsp;- &ensp;Applied best practices in Cloud Security, auditing, and implementing security controls.
          </span>
          <br />
          <span className="resume-description-text">
            &emsp;- &ensp;Analyse cloud infrastructures and recommend improvements for performance gains and cost<br />
            &emsp;&emsp; efficiency{" "}
          </span>
          <br />
        </div>
      </div>
    </div>,

    /* PROGRAMMING SKILLS */
    <div
      className="resume-screen-container programming-skills-container"
      key="programming-skills"
    >
      {programmingSkillsDetails.map((skill, index) => (
        <div className="skill-parent" key={index}>
          <div className="heading-bullet"></div>
          <span>{skill.skill}</span>
          <div className="skill-percentage">
            <div
              style={{ width: skill.ratingPercentage + "%" }}
              className="active-percentage-bar"
            ></div>
          </div>
        </div>
      ))}
    </div>,

    /* PROJECTS */
    <div className="resume-screen-container" key="projects">
      {projectsDetails.map((projectsDetails, index) => (
        <ResumeHeading
          key={index}
          heading={projectsDetails.title}
          subHeading={projectsDetails.subHeading}
          description={projectsDetails.description}
          fromDate={projectsDetails.duration.fromDate}
          toDate={projectsDetails.duration.toDate}
        />
      ))}
    </div>,

    /* Certifications */
    <div
      className="resume-screen-container certifications-container"
      key="certifications"
    >
      <ResumeHeading
        heading={"AWS Certified Cloud Practitioner"}
        subHeading={"Amazon Web Services (AWS)"}
        fromDate={"June"}
        toDate={"2024"}
      />
    </div>,

    /* Interests */
    <div className="resume-screen-container" key="interests">
      <ResumeHeading
        heading="Sports"
        description="I enjoy playing, watching, and following various sports such as basketball, soccer, tennis, and physical activities like
        running, cycling, swimming, weightlifting, and yoga, to maintain my physical health and well-being."
      />
      <ResumeHeading
        heading="Art and Creativity"
        description="I love painting, drawing, sculpting,and photography. I like to visit art galleries, take part in workshops."
      />
      <ResumeHeading
        heading="Music"
        description="I like listening to and creating music. I can play piano, sing, and dance. I Attend concerts at least once a month."
      />
      <ResumeHeading
        heading="Volunteering"
        description="I love to volunteer in community service, supporting charitable causes, and also participating in volunteer work at my local church."
      />
      <ResumeHeading
        heading="Coding and Programming"
        description="I also like learning coding languages, developing software, or building websites and applications."
      />
    </div>,
  ];

  const handleCarousal = (index) => {
    let offsetHeight = 360;

    let newCarousalOffset = {
      style: { transform: "translateY(" + index * offsetHeight * -1 + "px)" },
    };

    setCarousalOffsetStyle(newCarousalOffset);
    setSelectedBulletIndex(index);
  };

  const getBullets = () => {
    return resumeBullets.map((bullet, index) => (
      <div
        onClick={() => handleCarousal(index)}
        className={
          index === selectedBulletIndex ? "bullet selected-bullet" : "bullet"
        }
        key={index}
      >
        <img
          className="bullet-logo"
          src={require(`../../assets/Resume/${bullet.logoSrc}`)}
          alt="B"
        />
        <span className="bullet-label">{bullet.label}</span>
      </div>
    ));
  };

  const getResumeScreens = () => {
    return (
      <div
        style={carousalOffsetStyle.style}
        className="resume-details-carousal"
      >
        {resumeDetails.map((ResumeDetail) => ResumeDetail)}
      </div>
    );
  };

  useEffect(() => {
    return () => {
      /* UNSUBSCRIBE THE SUBSCRIPTIONS */
      fadeInSubscription.unsubscribe();
    };
  }, [fadeInSubscription]);

  return (
    <div
      className="resume-container screen-container fade-in"
      id={props.id || ""}
    >
      <div className="resume-content">
        <ScreenHeading
          title={"Résumé"}
          subHeading={"My Academic and Professional History/Experience."}
        />
        <div className="resume-card">
          <div className="resume-bullets">
            <div className="bullet-container">
              <div className="bullet-icons"></div>
              <div className="bullets">{getBullets()}</div>
            </div>
          </div>

          <div className="resume-bullet-details">{getResumeScreens()}</div>
        </div>
      </div>
    </div>
  );
};

export default Resume;